export const MIN_IMAGE_ZOOM = 1;
export const MAX_IMAGE_ZOOM = 4;

const IMAGE_ZOOM_BUTTON_STEP = 0.1;
const WHEEL_ZOOM_SENSITIVITY = 0.001;
const WHEEL_LINE_HEIGHT_PX = 16;

const clampImageZoom = (zoom: number) =>
  Math.min(MAX_IMAGE_ZOOM, Math.max(MIN_IMAGE_ZOOM, zoom));

export const stepImageZoom = (zoom: number, direction: -1 | 1) =>
  clampImageZoom(zoom + direction * IMAGE_ZOOM_BUTTON_STEP);

export const calculateWheelZoom = ({
  zoom,
  deltaY,
  deltaMode,
  viewportHeight,
}: {
  zoom: number;
  deltaY: number;
  deltaMode: number;
  viewportHeight: number;
}) => {
  const pixelDelta =
    deltaMode === 1
      ? deltaY * WHEEL_LINE_HEIGHT_PX
      : deltaMode === 2
        ? deltaY * Math.max(1, viewportHeight)
        : deltaY;

  return clampImageZoom(zoom * Math.exp(-pixelDelta * WHEEL_ZOOM_SENSITIVITY));
};
